import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';
import { InOrderState } from 'src/models/InOrder';

export interface GetAllInOrdersParams {
  limit?: number;
  offset?: number;
  orderBy?: 'id' | 'orderNumber' | 'issuedAt' | 'createdAt' | 'updatedAt';
  sortBy?: 'ASC' | 'DESC';
  search?: string;
  orderNumber?: string;
  entrySource?: 'MANUAL' | 'INVOICE_XML';
  issuedAtStartDate?: number;
  issuedAtEndDate?: number;
  state?: InOrderState;
}

@Injectable({
  providedIn: 'root'
})
export class InOrdersDataSourceService {
  baseUrl = `${environment.v3BaseUrl}/api/v3/admin-desktop`;

  constructor( private http: HttpClient ) { }

  getAllInOrders(params: GetAllInOrdersParams = {}) {
    return this.http.get(`${this.baseUrl}/in-orders`, {
      params: params as { [param: string]: string | number | boolean }
    }).toPromise();
  }

  getInOrderDetails(orderId: string) {
    return this.http.get(`${this.baseUrl}/in-orders/${orderId}`).toPromise();
  }
}
